import React from 'react';
import S from './Projects.module.scss';
import { mockProjects } from "../../shared/mock/projects";
import { ProjectItem } from "./ProjectItem";
import { Accordion } from "@mantine/core";

export const Projects = () => {
  return (
    <section className={S.container} id='projects'>
      <div className={S.projects}>
        <h1 className={S.title}>Продукты и платформы</h1>

        <Accordion
          classNames={S}
          className={S.projectsGrid}
          multiple
          variant="separated"
          defaultValue={[]}
        >
          {mockProjects.map((project) => (
            <ProjectItem key={project.id} project={project}/>
          ))}
        </Accordion>
      </div>
    </section>
  );
};